<div *ngIf="user">
	<mat-card class="card-block">
		<mat-card-header>
			<mat-card-title>Avdelning</mat-card-title>
		</mat-card-header>
		<mat-card-content>
			<form [formGroup]="form.controls" (ngSubmit)="setTeam()">
				<div class="row">
					<div class="col-9">
						<select
							class="form-control"
							formControlName="teamId"
						>
							<option value="">Ingen avdelning</option>
							<option 
								*ngFor="let team of teams" 
								[value]="team.id"
							>
								{{ team.name }}
							</option>
						</select>
					</div>
					<div class="col-3">
						<input
							type="submit"
							class="btn btn-primary btn-block"
							value="Uppdatera"
							[disabled]="!form.isValid()"
						/>
					</div>
				</div>
				<div style="padding-top: 10px">
					<form-state [form]="form"></form-state>
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</div>